import shajs from "sha.js";

export default function hashString(input: string): string {
  return shajs("sha256").update(input).digest("hex");
}
